import { FC, Fragment } from 'react';
import { Marker, Popup } from 'react-leaflet';
import { DivIcon, Icon, IconOptions } from 'leaflet';
import { Position } from 'ts/hotel/interfaces/Generic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { imgWaypointA, imgWaypointB } from 'constants/generic';

interface AdditionalMarkerOSMProps {
  onClickFrom: (from: Position) => void;
  onClickTo: (to: Position) => void;
  onClickCentered: (centered: Position) => void;
  value?: Position;
  icon: Icon<IconOptions> | DivIcon;
  zIndexOffset?: number;
}

const AdditionalMarkerOSM: FC<AdditionalMarkerOSMProps> = ({ value, ...props }) => {
  
  const { t } = useTranslation();
  return (
    <Fragment>
      {!!value && !!value?.lat && !!value?.lng && (
        <Marker zIndexOffset={props.zIndexOffset} position={value} icon={props.icon}>
          <Popup>
            <div className="map-marker map-marker-osm">
              <div className="marker-name">{value.address}</div>
              <div className="marker-actions">
                <button
                  className="btn btn-default"
                  onClick={() =>
                    props.onClickFrom({
                      ...value,
                    })
                  }
                >
                  <img src={imgWaypointA} alt="" /> {t('group.from')}
                </button>
                <button
                  className="btn btn-default"
                  onClick={() =>
                    props.onClickTo({
                      ...value,
                    })
                  }
                >
                  <img src={imgWaypointB} alt="" />
                  {t('group.to')}
                </button>
                <button
                  className="btn btn-default"
                  onClick={() => {
                    props.onClickCentered({
                      lat: value!.lat,
                      lng: value!.lng,
                      address: value!.address,
                      name: value!.address,
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faArrowRight} />
                  {t('hotel.center_me')}
                </button>
              </div>
            </div>
          </Popup>
        </Marker>
      )}
    </Fragment>
  );
};

export default withErrorBoundary(AdditionalMarkerOSM, 'AdditionalMarkerOSM');
